<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Prześlij listę BK do MDOK"
    title="Prześlij listę BK do MDOK"
    class="modal-big"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="submit"
    @close="close"
  >
    <div class="pack-preview">
      <iframe ref="iframe" :srcdoc="preview" :style="{ height: iframeHeight }" />
    </div>
  </w-modal>
</template>

<script>
import { Successes } from '@/enums/successes.enum';
import { iframeMixin } from '@/mixins/iframe';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import { koResource } from '@/resources/ko.resource';
import { getPaymentPackDetails } from '@/utils/paymentList';
import { serverError } from '@/utils/serverError';

// @vuese
// Modal podglądu paczki przed wysłaniem do MDOK
// @group Modals
export default {
  mixins: [iframeMixin(), notificationsMixin, modalMixin],
  data() {
    return { preview: '' };
  },

  computed: {
    paymentPackId() {
      return parseInt(this.$route.params.packId);
    },

    isIframeVisible() {
      return !!this.preview;
    }
  },

  beforeMount() {
    koResource
      .previewKoList({ packId: this.paymentPackId })
      .then(preview => (this.preview = preview))
      .catch(err => this.notifyError(serverError(err)));
  },

  methods: {
    submit() {
      koResource
        .sendKoListToMdok({ packId: this.paymentPackId })
        .then(() => {
          this.notifySuccess(Successes.KO_PAYMENT_PACK_PAID);
          getPaymentPackDetails(this.$route);
          this.close();
        })
        .catch(err => this.notifyError(serverError(err)));
    }
  }
};
</script>

<style>
.pack-preview {
  border: 1px solid black;
}

.pack-preview iframe {
  width: 99%;
  border: none;
}
</style>
